export const isUserSensedia = (user) => {
  return user?.organization?.name === "sensedia" ? true : false;
};
